
























import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import VoteButton from '@/components/VoteButton.vue';
import { OPTHINES } from './config';
import { Button, Toast } from 'vant';
Vue.use(Button);
@Component({
  components: {
    VoteList,
    VoteButton,
  },
})
export default class List extends Vue {
  option = OPTHINES;
  voteId: string = '';
  chooseFun(e: any) {
    const newArr = new Set(e);
    let lastArr = [];
    lastArr = Array.from(newArr);
    console.log('e', lastArr);

    this.voteId = JSON.stringify(lastArr);
    console.log('voteId', this.voteId);
  }
  votSuccess() {
    console.log('success');
    Toast.success('投票成功');
    setTimeout(() => {
      this.$router.go(0);
    }, 500);
  }
}
